import { render, staticRenderFns } from "./ModalAlert.vue?vue&type=template&id=46ac77fd&"
import script from "./ModalAlert.vue?vue&type=script&lang=js&"
export * from "./ModalAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports